<template>
  <transition name="slide-up">
    <div class="attachments-modal-dialog" v-show="isShow">
      <div class="mb-3 text-bold">Send Attachments</div>
      <!-- Grid -->
      <div class="files-grid">
        <div v-for="(f, i) in files" :key="f.id" class="file-card">
          <button class="btn-remove" @click="removeFile(i)">×</button>

          <div class="file-thumb">
            <b-img
              v-if="isImage(f.name)"
              alt="upload image"
              :src="f.preview"
              @error="handleImageSrc"
            />
            <template v-else-if="isVideo(f.name)">
              <video :src="f.base64" width="300" style="max-width: 50%"></video>
              <div class="video-preview">
                <font-awesome-icon icon="play"></font-awesome-icon>
              </div>
            </template>
            <div v-else class="attachment-file">
              <div>
                <font-awesome-icon icon="file-download"></font-awesome-icon>
              </div>
              <div class="attachment-name">{{ f.name }}</div>
            </div>
          </div>
        </div>

        <div class="file-card" @click="handleUploadFile">
          <div class="add-icon">
            <font-awesome-icon icon="plus" title="file attachment" />
          </div>
        </div>
      </div>

      <div class="hide-upload-panel">
        <UploadFile
          textFloat="File"
          placeholder="Please Choose File"
          format=""
          name="file"
          text="*Please upload only file .xlsx less than 10 MB"
          isRequired
          v-on:onFileChange="uploadFile"
          v-on:delete="deleteFile"
          :fileName="filename"
          v-model="attachment"
          id="uploadfile"
          :v="$v.filename"
          :isValidate="$v.filename.$error"
          ref="uploadFile"
        />
      </div></div
  ></transition>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import UploadFile from "@/components/inputs/UploadFile";

export default {
  components: { UploadFile },
  validations() {
    return {
      filename: { required },
    };
  },
  data() {
    return {
      filename: "",
      attachment: "",

      files: [],
      isShow: false,
    };
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
    },
    async submitOne(fileObj) {
      this.$bus.$emit("showLoading");
      try {
        const payload = {
          Base64String: fileObj.base64,
          is_video: false,
          is_file: true,
          type: 1,
          file_name: fileObj.name,
        };
        const result = await this.axios.post("/ticket/UploadFile", payload);

        fileObj.uploadedPath = result.data.detail;

        this.$emit("uploadFile", {
          fileName: fileObj.name,
          path: fileObj.uploadedPath,
        });
      } catch (error) {
        this.errorAlert(error.message);
      } finally {
        this.$bus.$emit("hideLoading");
      }
    },

    uploadFile(file) {
      const id = Date.now() + Math.random().toString(36).slice(2);
      const fileObj = {
        id,
        name: file.name,
        preview: "",
        base64: "",
        uploadedPath: "",
      };

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        fileObj.base64 = reader.result;
        if (fileObj.isImage) fileObj.preview = reader.result;

        this.files.push(fileObj);

        await this.submitOne(fileObj);

        this.filename = null;
        this.attachment = null;
        this.$v.filename.$reset();
      };
    },

    deleteFile() {
      this.attachment = null;
      this.filename = null;
    },

    removeFile(index) {
      const removed = this.files.splice(index, 1)[0];

      this.$emit("removeFile", removed);
    },

    handleUploadFile() {
      this.$refs.uploadFile.$refs.input.click();
    },

    isImage(u) {
      return /\.(png|jpg|jpeg|webp|gif|heic|heif)$/i.test(u);
    },
    isVideo(u) {
      return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(u);
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments-modal-dialog {
  background-color: white;
  bottom: 0;
  left: 0;
  height: 60vh;
  border-radius: 10px 10px 0 0;
  width: 100%;
  overflow: auto;
  padding-bottom: 2rem;
}

.files-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.file-card {
  position: relative;
  border: 2px dashed #e0e0e0;
  border-radius: 14px;
  background: #fff;
  min-height: 130px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.btn-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  font-size: 18px;
  line-height: 1;
  z-index: 1;
}

.file-thumb {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  max-height: 140px;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
    object-fit: cover;
  }
}

.hide-upload-panel {
  visibility: hidden;
  position: absolute;
  left: -9999px;
  top: -9999px;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
